export type RestangularEmployee = {
  id: number;
  fullname: string;
  wages: {
    base?: Array<{
      id: number;
      regularRate: number;
      userId: number;
    }>;
  };
};

export type Employee = {
  id: number;
  fullName: string;
  wage?: string;
  wageId?: number;
};

export type RestangularPosition = {
  id: number;
  name: string;
  color: string;
  wages: Array<{
    id: number;
    regularRate: number;
  }>;
};

export type Position = {
  id: number;
  name: string;
  color: string;
  wage?: string;
  wageId?: number;
};

export enum Tab {
  employees = 'employees',
  positions = 'positions',
}
